
<template>
	<div class="page-container">
		
		<HeaderLayout></HeaderLayout>
		<div class="content">
		    <div class="main-content">
				<h2 class="text-name">소개</h2>
				
				 
			</div>
		</div>


		
		<FooterLayout></FooterLayout>
	</div>	
	
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
  name: 'PageAbout',
  components: {
	  HeaderLayout,
	  FooterLayout,
  },
  data () {
	
	return {
  	  
	   
   }
  },
  created: function() {
},
  methods: {


  },
  mounted: function() {

	$('.content').css('min-height',$(window).height());
  },
  updated() {
		
	
  }

}
</script>

<style lang="scss" scoped>

.page-container {
	width:100%;
	background:#fff;
	margin:0;
	min-height:calc(100vh);
	.content {
		width:100%;
		height:auto;
		padding:150px 0 100px; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#fff;
		.main-content {
			width:830px;
			margin:auto;
			
		}
	}
	
}


</style>